import { namedMerger } from '../namedMerger';

export const ENTITY_IDENTITY_BINDINGS_QUERY_FIELD = 'entityIdentityBindings';

export const entityIdentityBindingsListKeyArgs = ['filter', 'parent'] as const;

export const entityIdentityBindingsListFieldPolicy = {
  keyArgs: [...entityIdentityBindingsListKeyArgs],
  merge: namedMerger(ENTITY_IDENTITY_BINDINGS_QUERY_FIELD),
};

export const entityIdentityBindingsListKeyArgsFieldPolicy = {
  keyArgs: [...entityIdentityBindingsListKeyArgs],
};

export const metricsV1EntityIdentityBindingTypePolicy = {
  keyFields: ['name'] as const,
};
